<template>
  <span
    class="student-tooltip-component student-tooltip non-highlightable"
    :data-note-title="tooltipData.title"
    :data-note-content="tooltipData.content"
    :index="id"
    @click.capture="handleClickAnnotation"
  >
    <cv-interactive-tooltip v-if="showTooltip" ref="studentInteractiveTooltip" direction="bottom">
      <!-- Student Tooltip Icon -->
      <template #trigger>
        <svg-icon name="StudentTooltip24" kind="richtext" />
      </template>
      <!-- Tooltip content -->
      <template #content>
        <div class="content-wrapper">
          <div class="content-header">
            <h6>{{ tooltipData.title }}</h6>
          </div>
          <div class="content-body">
            {{ tooltipData.content }}
          </div>
        </div>
      </template>
    </cv-interactive-tooltip>

    <!-- Just the Student Tooltip Icon -->
    <svg-icon v-else name="StudentTooltip24" kind="richtext" />
  </span>
</template>

<script setup lang="ts">
import { useDynamicMountChild } from "@plugins/common/composables/dynamic-mount-child.ts";
import { onMounted } from "vue";

// Props
const props = defineProps({
  tooltipData: { type: Object, default: () => ({}) },
  showTooltip: { type: Boolean, default: true },
  id: { type: String, default: "0" },
  // eslint-disable-next-line vue/prop-name-casing
  dynamicMountChildMixin_parentComponent: { type: Object, default: null },
  // eslint-disable-next-line vue/prop-name-casing
  dynamicMountChildMixin_isDynamicallyMounted: { type: Boolean, default: false },
});

// Emits
const emit = defineEmits(["loaded", "handleAnchorAnnotation"]);

useDynamicMountChild({
  dynamicMountChildMixin_parentComponent: props.dynamicMountChildMixin_parentComponent,
  dynamicMountChildMixin_isDynamicallyMounted: props.dynamicMountChildMixin_isDynamicallyMounted,
});

// Methods
const handleClickAnnotation = () => {
  emit("handleAnchorAnnotation", props.id);
};

// Mounted
onMounted(() => {
  emit("loaded", props.id);
});
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/colors";

.student-tooltip-component {
  .cv-interactive-tooltip {
    display: inline-block;
    width: 1.5rem;
    height: 1.5rem;
    vertical-align: sub;

    .bx--tooltip__label .bx--tooltip__trigger {
      margin-left: 0;

      .sls-icon {
        fill: none;
      }
    }
  }
  .sls-icon {
    vertical-align: middle;
    color: $interactive-01;
    // Override fill propety set by Carbon default styling
    fill: none;

    path {
      stroke: currentColor;
    }
  }
}
</style>
